import React, { Fragment } from 'react';
import styled from '@emotion/styled';
import { Box, Text, Heading } from 'roo-ui/components';
import { useSelector } from 'react-redux';
import ContentRow from 'pages/BookingConfirmation/ContentRow';
import ContentWrapper from 'pages/BookingConfirmation/ContentWrapper';
import OccupantsSummary from 'components/OccupantsSummary';
import { getTravelArranger, getLeadGuest, getOccupants, getReservation } from 'store/booking/bookingSelectors';

const StyledText = styled(Text)`
  line-height: 1.75;
`;

const GuestDetails = () => {
  const travelArranger = useSelector(getTravelArranger);
  const leadGuest = useSelector(getLeadGuest);
  const occupants = useSelector(getOccupants);
  const reservation = useSelector(getReservation);

  const { specialRequests } = reservation;

  return (
    <Fragment>
      <Heading.h3 fontSize={['base', 'md']} color="greys.charcoal" mb={4}>
        Guest details
      </Heading.h3>
      <StyledText data-testid="reservation-by">
        Reserved by {travelArranger.title} {travelArranger.firstName} {travelArranger.lastName}
      </StyledText>
      <Text fontSize="sm" color="greys.steel" display="block" mb={3}>
        When you check in, you will need to provide photo ID that matches this name.
      </Text>

      <OccupantsSummary fontSize="base" occupants={occupants} />
      <ContentWrapper mt={5}>
        <ContentRow flexDirection={['column', 'row']} justifyContent="flex-start" mb={4}>
          <Box width={[1, 0.2]}>
            <StyledText fontSize={['sm', 'base']}>Contact number</StyledText>
          </Box>
          <Box>
            <StyledText fontSize="base" data-testid="contact-number">
              {travelArranger.phone}
            </StyledText>
          </Box>
        </ContentRow>

        <ContentRow flexDirection={['column', 'row']} justifyContent="flex-start" mb={4}>
          <Box width={[1, 0.2]}>
            <StyledText fontSize={['sm', 'base']}>Email address</StyledText>
          </Box>
          <Box>
            <StyledText fontSize="base" data-testid="email-address">
              {travelArranger.email}
            </StyledText>
          </Box>
        </ContentRow>

        {leadGuest.qffNumber && (
          <ContentRow flexDirection={['column', 'row']} justifyContent="flex-start" mb={4}>
            <Box width={[1, 0.2]}>
              <StyledText fontSize={['sm', 'base']} data-testid="qff-number-label">
                Qantas Frequent Flyer
              </StyledText>
            </Box>
            <Box>
              <StyledText fontSize="base" data-testid="qff-number">
                {leadGuest.qffNumber}
              </StyledText>
            </Box>
          </ContentRow>
        )}

        {travelArranger.abn && (
          <ContentRow flexDirection={['column', 'row']} justifyContent="flex-start" mb={4}>
            <Box width={[1, 0.2]}>
              <StyledText fontSize={['sm', 'base']} data-testid="abn-label">
                ABN
              </StyledText>
            </Box>
            <Box>
              <StyledText fontSize="base" data-testid="abn">
                {travelArranger.abn}
              </StyledText>
            </Box>
          </ContentRow>
        )}

        {specialRequests && (
          <ContentRow flexDirection={['column', 'row']} justifyContent="flex-start" mb={4}>
            <Box width={[1, 0.2]}>
              <StyledText fontSize={['sm', 'base']} data-testid="special-requests-label">
                Special Requests
              </StyledText>
            </Box>
            <Box>
              <StyledText fontSize="base">{specialRequests}</StyledText>
            </Box>
          </ContentRow>
        )}
      </ContentWrapper>
    </Fragment>
  );
};

GuestDetails.displayName = 'GuestDetails';

export default GuestDetails;
